(() => {
  function initialize(root) {
    if (root.dataset.niuReady) return;
    root.dataset.niuReady = 'true';
    const translations = JSON.parse(root.querySelector('[data-niu-translations]').textContent);
    const variant = JSON.parse(root.querySelector('[data-niu-variant]').textContent);
    const form = root.querySelector('form');
    const status = root.querySelector('[data-niu-status]');
    const languageSelect = root.querySelector('[data-niu-language]');
    const cartLink = root.querySelector('[data-niu-cart-link]');
    let language = 'en';
    let busy = false;
    const buttons = [...root.querySelectorAll('[data-niu-action]')];
    const routesRoot = window.Shopify?.routes?.root || '/';
    function updateButtons() {
      buttons.forEach(button => {
        button.disabled = busy || !variant.available;
        button.textContent = translations[language][busy ? 'pending' : !variant.available ? 'unavailable' : button.dataset.niuAction];
      });
    }
    function translate(next) {
      language = translations[next] ? next : 'en';
      const d = translations[language];
      root.lang = language;
      languageSelect.value = language;
      root.querySelectorAll('[data-niu-text]').forEach(el => { el.textContent = d[el.dataset.niuText]; });
      root.querySelectorAll('[data-niu-name]').forEach(el => { el.textContent = d.names[+el.dataset.niuName]; });
      root.querySelectorAll('[data-niu-spec]').forEach(el => { el.textContent = d.specs[+el.dataset.niuSpec]; });
      root.querySelector('[data-niu-photo="overall"]').alt = d.altOverall;
      root.querySelector('[data-niu-photo="detail"]').alt = d.altDetail;
      root.querySelector('.niu-gallery-nav').setAttribute('aria-label', d.gallery);
      const buildProperty = root.querySelector('[data-niu-property]');
      buildProperty.name = `properties[${d.propBuild}]`;
      buildProperty.value = d.propValue;
      const languageProperty = root.querySelector('[data-niu-property-language]');
      languageProperty.name = `properties[${d.propLanguage}]`;
      languageProperty.value = languageSelect.selectedOptions[0].textContent;
      if (status.dataset.message) status.textContent = d[status.dataset.message];
      document.title = `NIU FX · ${d.subtitle} | Ghostfire Archive`;
      updateButtons();
    }
    languageSelect.addEventListener('change', () => translate(languageSelect.value));
    root.querySelectorAll('[data-niu-image]').forEach(button => button.addEventListener('click', () => {
      const selected = button.dataset.niuImage;
      root.querySelectorAll('[data-niu-photo]').forEach(img => { img.hidden = img.dataset.niuPhoto !== selected; });
      root.querySelectorAll('[data-niu-image]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
    }));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy || !variant.available) return;
      busy = true;
      status.textContent = '';
      delete status.dataset.message;
      delete status.dataset.error;
      cartLink.hidden = true;
      updateButtons();
      const action = event.submitter?.dataset.niuAction || 'add';
      try {
        const data = new FormData(form);
        // 商品价格和可售状态均由 Shopify 服务端验证。
        const response = await fetch(`${routesRoot}cart/add.js`, {method:'POST',headers:{Accept:'application/json'},body:data});
        if (!response.ok) throw new Error(`Cart ${response.status}`);
        const added = await response.json();
        if (Number(added.variant_id || added.id) !== Number(variant.id)) throw new Error('Variant mismatch');
        if (action === 'buy') {
          window.location.assign(`${routesRoot}checkout`);
          return;
        }
        window.location.assign(`${routesRoot}cart`);
        status.dataset.message = 'cartSuccess';
        status.textContent = translations[language].cartSuccess;
        cartLink.hidden = false;
      } catch {
        status.dataset.message = 'cartError';
        status.dataset.error = 'true';
        status.textContent = translations[language].cartError;
        busy = false;
        updateButtons();
      }
    });
    translate('en');
  }
  document.querySelectorAll('[data-niu-build]').forEach(initialize);
  if (!window.niuBuildEditorListener) {
    window.niuBuildEditorListener = true;
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-niu-build]').forEach(initialize));
  }
})();
